import {
  HttpContext,
  HttpErrorResponse,
  HttpEvent,
  HttpEventType,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { OperationInfoService } from '../../long-operations/operation-info.service';
import { urlPathname } from '../error-response/http-error-interceptor';
import { INTERCEPTOR_CONFIG, LOADING, LOADING_TOKEN } from '../tokens';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private readonly inProgress: Map<string, HttpContext> = new Map();

  private config = inject(INTERCEPTOR_CONFIG);
  private operationService = inject(OperationInfoService);

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.url.includes(this.config.apiUrl) && !this.hasLoadingToken(request.context)) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      tap({
        next: (event: HttpEvent<unknown>) => {
          if (event.type === HttpEventType.Sent && this.hasLoadingToken(request.context)) {
            this.registerEndpoint(request.clone());
            this.operationService.startLoading({ spinner: 'local' });
          }

          if (event.type === HttpEventType.Response) {
            if (!event.url) {
              console.error('No URL provided');
              return;
            }

            this.unregisterEndpoint(event.url);
          }
        },

        error: (error: HttpErrorResponse) => {
          console.error(error);
          if (!error.url) {
            console.error('No URL provided');
            return;
          }

          this.unregisterEndpoint(error.url);
        },
      }),
    );
  }

  private hasLoadingToken(context: HttpContext = new HttpContext()): boolean {
    return context.get(LOADING_TOKEN) === LOADING;
  }

  private registerEndpoint(request: HttpRequest<unknown>): void {
    this.inProgress.set(urlPathname(request.url), request.context ?? new HttpContext());
  }

  private unregisterEndpoint(url: string): void {
    if (this.hasLoadingToken(this.inProgress.get(urlPathname(url)))) {
      this.inProgress.delete(urlPathname(url));

      if (!this.inProgress.size) {
        this.operationService.stopLoading({ spinner: 'local' });
      }
    }
  }
}
